import React from "react"
import { NavLink as _NavLink } from "react-router-dom"
import styled from "styled-components"

import Icon, { IconName } from "components/icon"
import { FlexRow } from "components/box"
import { Separator } from "components/separator"
import { Paragraph } from "components/text"
import { DashboardCard as Card } from "./styles"

const NavLink = styled(_NavLink)`
  text-decoration: none;
`

type Props = {
  title: string
  subtitle: string
  rightLinkText: string
  rightLinkTo: string
  rightLinkIcon: IconName
  bottomLinkTo: string
  bottomLinkText: string
  count: number
  showNotification?: boolean
}

const DashboardCard = ({
  title,
  subtitle,
  rightLinkText,
  rightLinkTo,
  rightLinkIcon,
  bottomLinkTo,
  bottomLinkText,
  count,
  showNotification
}: Props) => (
  <Card.Container>
    <Card.Content>
      <NavLink to={bottomLinkTo}>
        <Card.Title>{title}</Card.Title>
        <FlexRow alignItems="center">
          <Card.Count>{count}</Card.Count>
          <Paragraph>{subtitle}</Paragraph>
        </FlexRow>
        <Separator borderColor="silver" my={4} />
      </NavLink>
      <Card.Link to={bottomLinkTo}>{bottomLinkText}</Card.Link>
    </Card.Content>

    <NavLink to={rightLinkTo}>
      <Card.IconContainer>
        <Card.RoundIcon>
          <Icon name={rightLinkIcon} />
          {showNotification && <Card.NotificationIndicator />}
        </Card.RoundIcon>
        <Paragraph bold>{rightLinkText}</Paragraph>
      </Card.IconContainer>
    </NavLink>
  </Card.Container>
)

export default DashboardCard
